import React, { useEffect } from 'react'
import styles from './ChangeLogs.module.css'
import ChangeLog from './ChangeLog'

const ChangeLogs = (props) => {
    const { changeLogList } = props
    const changeLogElements = changeLogList.map((changeLog) => {
        return <ChangeLog title={changeLog.title} date={changeLog.date}>{changeLog.body}</ChangeLog>
    })
    return (
        <article className={styles['changelogs-container']}>
            {changeLogElements}
        </article>
    )
}

export default ChangeLogs

